// frontend/src/components/tablekit/csv.js

function headerLabel(col) {
    return col.header ?? col.key;
  }
  
  function cellValue(row, col) {
    const raw = col.accessor ? col.accessor(row) : row[col.key];
    if (raw == null) return '';
    if (typeof raw === 'string') return raw.replace(/\r?\n/g, ' ');
    if (typeof raw === 'number') return String(raw);
    if (raw instanceof Date) return raw.toISOString();
    return String(raw);
  }
  
  export function rowsToCsv(columns, rows) {
    const headers = columns.map(headerLabel);
    const lines = [headers.join(',')];
  
    for (const r of rows) {
      const vals = columns.map(c => {
        const v = cellValue(r, c);
        // RFC4180 quoting
        const needsQuote = /[",\n]/.test(v);
        const safe = needsQuote ? `"${v.replace(/"/g, '""')}"` : v;
        return safe;
      });
      lines.push(vals.join(','));
    }
    return lines.join('\n');
  }
  
  /** Export parent rows; for subTables, export each as a separate CSV blob */
  export function buildCsvBlobs({ title = 'table', columns, rows, subTables = [] }) {
    const blobs = [];
    // parent
    blobs.push({
      filename: `${title}.csv`,
      content: rowsToCsv(columns, rows),
    });
  
    // each subtable becomes one CSV concatenating all children with a parent pointer
    for (const st of subTables) {
      const stCols = [
        { key: '__parent__', header: 'Parent Key', accessor: (r) => r.__parentKey },
        ...st.columns
      ];
      const childRows = [];
      for (const parent of rows) {
        const list = Array.isArray(parent[st.key]) ? parent[st.key] : [];
        for (const item of list) {
          childRows.push({ __parentKey: parent.key ?? '', ...item });
        }
      }
      blobs.push({
        filename: `${title}__${st.title || st.key}.csv`,
        content: rowsToCsv(stCols, childRows),
      });
    }
  
    return blobs;
  }
  